import libphonenumber from "google-libphonenumber";

const phoneUtil = libphonenumber.PhoneNumberUtil.getInstance();

export type PhoneCountryType = {
  name?: string;
  dialCode?: string;
  countryCode?: string;
  format?: string;
  iso2?: string;
  priority?: number;
  mainCode?: boolean;
};

/**
 * Gets the ISO 3166-1 A-2 Country Code based on a phone number input.
 * If it cannot be found, a defaultCountryCode is used.
 */
export const getCountryCodeFromPhoneInput = (
  inputNumber: string,
  defaultCountryCode = "ca"
) => {
  try {
    // Number must be in international format with +DIAL-CODE to get the country code
    const intlPhoneNumber = `+${inputNumber}`;
    const numberObj = phoneUtil.parseAndKeepRawInput(
      intlPhoneNumber,
      defaultCountryCode
    );
    const countryCode = phoneUtil.getRegionCodeForNumber(numberObj);

    // convert to lowercase to match the country code expected in the phone number input
    return countryCode?.toLowerCase();
  } catch (e) {
    return defaultCountryCode;
  }
};

// Minimum digits required for a valid phone number (excluding dial code)
// Most countries have 7-10 digit national numbers
const MIN_PHONE_DIGITS = 7;

/**
 * Validates a phone number by checking minimum digit count.
 * Does NOT validate region-specific rules like area codes.
 * This allows formatting to work while being lenient on validation.
 *
 * @param inputNumber - The phone number to validate (may include dial code)
 * @returns true if the number has enough digits
 */
export const isValidPhoneInput = (inputNumber: string): boolean => {
  // Strip all non-digit characters
  const digitsOnly = inputNumber.replace(/\D/g, "");
  // Check minimum digit count
  return digitsOnly.length >= MIN_PHONE_DIGITS;
};
